import { getGraphql } from '../static/graphql/getGraphql.js'

export const state = () => ({
  loading: [],
  fundAccounts: [],
  withdrawalExpanded: false,
  showWithdrawalButton: false,
  memberPayments: [],
  autopay: {
    isEnabled: null,
    entityPaymentUuid: null,
  },
})

export const mutations = {
  setWithdrawalExpanded(state, payload) {
    state.withdrawalExpanded = payload
  },
  setFunds(state, payload) {
    state.fundAccounts = payload
  },
  updateFunds(state, payload) {
    const updatedFunds = []
    // loop through state.fundAccounts and add active issuing accounts
    // and other fund accounts, to the updatedFunds array
    console.warn('updateFunds')
    console.warn('number of fund accounts', state.fundAccounts.length)
    let cardId = ''

    // Loop through fundAccounts to filter out inactive issuing cards
    // by comparing the card_id to the list in the payload
    for (let i = 0; i < state.fundAccounts.length; i++) {
      if (state.fundAccounts[i]?.accountType === 'issuing_card') {
        try {
          // Parse the meta string into JSON
          const meta = JSON.parse(state.fundAccounts[i]?.meta)
          cardId = meta?.card_id // eslint-disable-line
        } catch (e) {
          console.log(e)
        }
        if (payload.includes(cardId)) {
          updatedFunds.push(state.fundAccounts[i])
        }
      } else {
        updatedFunds.push(state.fundAccounts[i])
      }
    }
    // Update the state
    state.fundAccounts = updatedFunds
  },
  setLoading(state, payload) {
    state.loading.push(payload.key)

    // unique the array
    state.loading = [...new Set(state.loading)]

    // remove
    if (!payload.value) {
      state.loading = state.loading.filter((e) => e !== payload.key)
    }
  },
  clearData(state, payload) {
    console.log(state)
    console.log(payload)
    state.loading = []
    state.fundAccounts = []
  },
  setAutopay(state, payload) {
    state.autopay = Object.assign({}, state.autopay, payload)
  },
  setMemberPayments(state, payload) {
    state.memberPayments = payload
  },
}

export const actions = {
  async getFundAccounts(context) {
    try {
      context.commit('clearData')
      console.log('*** entered getFundAccounts ***')

      let response = null

      // Perform graph call w/ graceful fallback to pre MemberPayments
      // TODO: when fully merged and fallback no longer required
      try {
        const query = await getGraphql('query-my-accounts.graphql')
        context.commit('setLoading', { key: 'getFundAccounts', value: true })
        response = await this.$axios.$post('/GRAPHQL_URL/', {
          query,
        })
      } catch (e) {
        const query = await getGraphql('query-my-accounts-pre-smp.graphql')
        context.commit('setLoading', { key: 'getFundAccounts', value: true })
        response = await this.$axios.$post('/GRAPHQL_URL/', {
          query,
        })
      }

      // account storage
      const combinedAccounts = []

      // Massage my fund accounts
      const myselfRelationship = response.data?.me?.relationships?.myself
        ? response.data?.me?.relationships?.myself
        : []

      const myselfRelationshipFundAccounts = myselfRelationship.filter((x) => {
        if (['individual'].includes(x.entityType)) {
          return true
        }
        return false
      })

      console.log(
        'myselfRelationshipFundAccounts',
        myselfRelationshipFundAccounts
      )

      for (let i = 0; i < myselfRelationshipFundAccounts.length; i++) {
        const parent = myselfRelationshipFundAccounts[i]
        for (let j = 0; j < parent.funds.accounts.length; j++) {
          const account = parent.funds.accounts[j]
          combinedAccounts.push({
            ...account,
            entityType: parent.entityType,
            name: parent.name,
          })
        }
      }

      // TODO:  Add visibility on other funds a user may have access to,
      //        like "family" or "social group" accounts.

      context.commit('setFunds', combinedAccounts)

      // store memberPayments
      if (myselfRelationship[0].funds.memberPayments !== undefined) {
        context.commit(
          'setMemberPayments',
          myselfRelationship[0].funds.memberPayments
        )
      }

      // store autopay config
      if (myselfRelationship[0].funds.autopay !== undefined) {
        context.commit('setAutopay', myselfRelationship[0].funds.autopay)
      }
    } catch (e) {
      console.log('Error getting fund accounts', e)
    } finally {
      context.commit('setLoading', { key: 'getFundAccounts', value: false })
    }
    console.log('*** exiting getFundAccounts ***')
  },
}

export const getters = {
  accountByAccountId: (state) => (accountId) => {
    return state.fundAccounts.find((x) => x.accountUuid === accountId)
  },
  memberPaymentStatusCounts: (state) => {
    const statusCounts = {}
    for (let i = 0; i < state.memberPayments.length; i++) {
      const status = state.memberPayments[i].status
      if (!(status in statusCounts)) {
        statusCounts[status] = 0
      }
      statusCounts[status] += 1
    }
    return statusCounts
  },
}
